import { FC, Fragment } from 'react';

import { AccessAvatar } from '../../workspaces/components/access/access-avatar';

/**
 * A visitor's lettered avatar and name, with an optional second line — title, organisation — split
 * by the same small dot the Overview cards use.
 */
export const VisitorName: FC<{ details?: string[]; name: string }> = ({ details = [], name }) => (
  <span className="flex min-w-0 items-center gap-2">
    <AccessAvatar className="size-6" label={name} labelClassName="text-[9.6px] leading-[14.4px]" />
    <span className="flex min-w-0 flex-col">
      <span className="truncate">{name}</span>
      {details.length > 0 && (
        <span className="flex min-w-0 items-center gap-2 text-label-sm font-medium text-gray-400">
          {details.map((detail, index) => (
            <Fragment key={index}>
              {index > 0 && <span className="size-1 shrink-0 rounded-full bg-[#D9D9D9]" />}
              <span className="truncate">{detail}</span>
            </Fragment>
          ))}
        </span>
      )}
    </span>
  </span>
);
